/**
 * Google Analytics 4 Configuration
 * Supports both REACT_APP_GA4_MEASUREMENT_ID (preferred) and REACT_APP_GA_MEASUREMENT_ID (legacy)
 */

// Get Google Analytics Measurement ID from environment variable
// Prioritize REACT_APP_GA4_MEASUREMENT_ID for consistency, fallback to legacy naming
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || process.env.REACT_APP_GA_MEASUREMENT_ID || '';

// Check if Google Analytics is enabled
export const isGAEnabled = () => {
  return GA_MEASUREMENT_ID && GA_MEASUREMENT_ID.startsWith('G-') && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX';
};

// Google Analytics 4 configuration
export const GA_CONFIG = {
  measurementId: GA_MEASUREMENT_ID,
  enabled: isGAEnabled(),
  // Development mode - set to false to disable GA in development
  debug: process.env.NODE_ENV === 'development' ? false : false,
};
